// extracted by mini-css-extract-plugin
export default {"container":"InfoVendorTab_container__OnY7N"};